import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'

export const Reports = () => {
  let [startDate, setStartDate] = useState('')
  let [endDate, setEndDate] = useState('')
  let [localError, setLocalError] = useState('')
  const handleDateChange = (evt, dateName) => {
    if (dateName === 'start') {
      setStartDate(evt.target.value)
    } else {
      setEndDate(evt.target.value)
    }
  }

  const genReport = async e => {
    e.preventDefault()
    setLocalError('')
    try {
      await client.post(endpoints.generateReport(), {
        startDate,
        endDate,
      })
      location.reload()
    } catch (err) {
      console.error(err)
      if (err.response.status === 400) {
        setLocalError(err.response.data.msg)
      } else {
        toast.error(`There was an error trying to generate the report. ${err}`, { autoClose: false })
      }
    }
  }

  return (
    <React.Fragment>
      <h2>Reports</h2>
      <p>
        This report will generate a CSV File that includes all codes that have
        been redeemed at any point in time from Access Code Orders that were
        paid for during the period specified.
      </p>
      <p>The report is inclusive of both days selected.</p>
      <Form horizontal onSubmit={e => genReport(e)}>
        <Form.Group className="d-flex">
          <input
            className="w-25 form-control"
            type="date"
            onChange={e => handleDateChange(e, 'start')}
            required
          />
          <span className="mx-3 mt-3">through</span>
          <Form.Control
            type="date"
            className="w-25"
            onChange={e => handleDateChange(e, 'end')}
            required
          />
        </Form.Group>
        {localError && <div className="text-danger">{localError}</div>}
        <Button
          className="mt-5 btn-myed btn-primary-myed text-white"
          type="submit"
        >
          <i className="fa-light fa-rocket mr-2" />
          Generate Report
        </Button>
      </Form>
    </React.Fragment>
  )
}
